import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyorDetailsComponent } from './components/surveyor-details/surveyor-details.component';
import { ViewDocModalComponent } from './components/view-doc-modal/view-doc-modal.component';
import { ActionDocModalComponent } from './components/action-doc-modal/action-doc-modal.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { DeploymentComponent } from '../modules/farm-app/deployment/deployment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchFilter } from './pipes/searchFilter.pipe';
import { LabShipmentComponent } from './components/lab-shipment/lab-shipment.component';
import { LabSampleComponent } from './components/lab-sample/lab-sample.component';
import { LabCartComponent } from './components/lab-cart/lab-cart.component';
import { LabShipmentModalComponent } from './components/lab-shipment-modal/lab-shipment-modal.component';
import { LabSampleModalComponent } from './components/lab-sample-modal/lab-sample-modal.component';
import { LabCartModalComponent } from './components/lab-cart-modal/lab-cart-modal.component';
import { ViewMultipleDocModalComponent } from './components/view-multiple-doc-modal/view-multiple-doc-modal.component';
import { SelectDateComponent } from './components/select-date/select-date.component';
import { DateRangePickerComponent } from './components/date-range-picker/date-range-picker.component';



@NgModule({
  declarations: [
    SurveyorDetailsComponent,
    ViewDocModalComponent,
    ActionDocModalComponent,
    VideoPlayerComponent,
    DeploymentComponent,
    SearchFilter,
    LabShipmentComponent,
    LabSampleComponent,
    LabCartComponent,
    LabShipmentModalComponent,
    LabSampleModalComponent,
    LabCartModalComponent,
    ViewMultipleDocModalComponent,
    SelectDateComponent,
    DateRangePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[
    SurveyorDetailsComponent,
    ViewDocModalComponent,
    ActionDocModalComponent,
    VideoPlayerComponent,
    DeploymentComponent,
    SearchFilter,
    LabShipmentModalComponent,
    LabSampleModalComponent,
    LabCartModalComponent,
    ViewMultipleDocModalComponent,
    SelectDateComponent,
    DateRangePickerComponent
  ]
})
export class SharedModule { }
